module.exports = __webpack_public_path__ + "img/login_title.bf68ad10.png";